/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function(){
  var svgIcon = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 4 7"><path fill="#444" d="M4 3.5L0 7V0z"></path></svg>`;
  var klaviyoFormBtn = setInterval(function(){
    $('.newsletter-wrapper .klaviyo-form button,.site-footer__newsletter .klaviyo-form button').addClass('btn-icon');
    $('.newsletter-wrapper .klaviyo-form button,.site-footer__newsletter .klaviyo-form button').append(svgIcon);
    if( $('.newsletter-wrapper .klaviyo-form button,.site-footer__newsletter .klaviyo-form button').hasClass('btn-icon')){
      clearInterval(klaviyoFormBtn);
    }
  },100);
});

// Covet.pics
// listen when item is added to cart
document.addEventListener('addToCart:covetPics', function(e) {  		
  Rebuy.Cart.fetchCart()
  Rebuy.SmartCart.show();
});